import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export interface ISettingStateSlice {
  notifications: INotificationSettings | null;
  notificationState: IReduxLoadingState;
  localBetaFeature: boolean;
  editInfoSelectedPCNotification?: BEAPerPatientSetting | null;
}

const name = "notification";

export const initialState: ISettingStateSlice = {
  notifications: null,
  notificationState: "pending",
  localBetaFeature: true,
  editInfoSelectedPCNotification: null,
};

export const settingSlice = createSlice({
  name,
  initialState,
  reducers: {
    setNotificationSettings(
      state,
      action: PayloadAction<INotificationSettings>
    ) {
      state.notifications = action.payload;
    },
    setEditInfoSelectedPCNotification(
      state,
      action: PayloadAction<BEAPerPatientSetting | null>
    ) {
      state.editInfoSelectedPCNotification = action.payload;
    },
    setLocalBetaFeature(state, action: PayloadAction<boolean>) {
      state.localBetaFeature = action.payload;
    },
  },
});

export const {
  setNotificationSettings,
  setLocalBetaFeature,
  setEditInfoSelectedPCNotification,
} = settingSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: ["localBetaFeature", "editInfoSelectedPCNotification"],
  },
  settingSlice.reducer
);

export default persistedReducer;
